"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentSelection = exports.ChildrenContainer = exports.CurrentSelectionContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const Icon_1 = require("../Icon");
const Input_1 = require("../Input");
exports.CurrentSelectionContainer = styled_components_1.default.div `
  ${Input_1.Input.ContainerStyle};
  align-items: center;
  column-gap: ${style_1.default.Layout.Spacing.Micro};
  cursor: pointer;
  display: flex;
  grid-template-columns: 1fr auto;
`;
exports.ChildrenContainer = styled_components_1.default.div `
  width: 100%;
`;
const CurrentSelection = ({ onClick, children, }) => {
    return ((0, jsx_runtime_1.jsxs)(exports.CurrentSelectionContainer, Object.assign({ onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(exports.ChildrenContainer, { children: children }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, Object.assign({ color: style_1.default.Color.Gray.S600 }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon.CaretDown, {}) }))] })));
};
exports.CurrentSelection = CurrentSelection;
